<template>
  <section name="info" class="info_sb">
    <div class="wrapper info_content">
      <span
        :style="!content.media ? '' : 'background-image: url(' + (content.media.full_url) + ')'"
        class="info_image"
      ></span>
      <div class="info_text">
        <img src="/svg/ic_more_info.svg" alt="ic_info" class="star-icon mb-4" />
        <h2>
          {{ content.title }}
        </h2>
        <p v-html="content.content_1"></p>
        <p v-html="content.content_2"></p>
      </div>
    </div>
    <div class="wrapper text-black">
      <div class="order-now-card">
        <span>
          <h3>{{ order.title }}</h3>
          <p>{{ order.content_1 }}</p>
          <p v-html="order.content_2"></p>
        </span>
        <button @click="openModal()" class="btn">Fazer pedido</button>
      </div>
      <div class="other-conditions">
        <h4 class="other-conditions-title">{{ terms.title }}</h4>
        <span v-html="terms.content_1"></span>
        <span v-html="terms.content_2"></span>
      </div>
    </div>
    <order-boat-form
      @closeModal="closeModal()"
      :isModalOpen="isModalOpen"
      :formFields="formFields"
      formTitle="pedido de sushiboat"
      formDescription="Por favor, preenche os campos abaixo. Após o envio do formulário, serás contactado para combinar o local de recolha do barco."
    >
    </order-boat-form>
  </section>
</template>

<script>
export default {
  props: {
    content: {
      required: true,
    },
    order: {
      required: true,
    },
    terms: {
      required: true,
    },
  },
  methods: {
    toggleScroll() {
      document.querySelector("html").classList.toggle("no-scroll");
      document.querySelector("body").classList.toggle("no-scroll");
    },
    openModal() {
      this.toggleScroll();
      this.isModalOpen = true;
    },
    closeModal() {
      this.toggleScroll();
      this.isModalOpen = false;
    },
  },
  data() {
    return {
      isModalOpen: false,
      formFields: {
        name: {
          label: "nome",
          type: "text",
          placeholder: "Introduz o teu nome",
        },
        email: {
          label: "e-mail",
          type: "text",
          placeholder: "Introduz o teu e-mail",
        },
        phone: {
          label: "telefone",
          type: "phone",
          placeholder: "Introduz o teu telemóvel",
        },
        type: {
          label: "tipo",
          placeholder: "small",
          type: "select",
          options: ["big", "small"],
        },
        date: { label: "dia", type: "date" },
        time: { label: "hora", type: "time", placeholder: "14:00" },
        message_content: {
          label: "mensagem",
          type: "textarea",
          placeholder: "Introduz a tua mensagem",
        },
      },
    };
  },
};
</script>
